/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Error_No_FilesInputs */

const en_claims_error_no_files = /** @type {(inputs: Claims_Error_No_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A minimum of 1 file is needed per submission.`)
};

const fr_claims_error_no_files = /** @type {(inputs: Claims_Error_No_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un minimum de 1 fichier est requis par soumission.`)
};

/**
* | output |
* | --- |
* | "A minimum of 1 file is needed per submission." |
*
* @param {Claims_Error_No_FilesInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_error_no_files = /** @type {((inputs?: Claims_Error_No_FilesInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Error_No_FilesInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_error_no_files(inputs)
	return fr_claims_error_no_files(inputs)
});